import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import {
  DataService,
  ModalService,
  NotificationService,
  SharedModule,
  TypedBaseListComponent,
} from "@bb-vendure/admin-ui/core";
import { CustomDetailComponent } from "@vendure/admin-ui/core";
import { Observable, take } from "rxjs";

import {
  CorporateDiscountsDocument,
  DeleteCorporateDiscountDocument,
} from "src/generated-gql/graphql";
import { CorperateDiscountDialogComponent } from "./cdt-dialog/cdt-dialog.component";
@Component({
  templateUrl: "./cdt.component.html",
  standalone: true,
  imports: [SharedModule],
})
export class CorperateDiscountTableComponent
  extends TypedBaseListComponent<
    typeof CorporateDiscountsDocument,
    "corporateDiscounts"
  >
  implements CustomDetailComponent, OnInit
{
  entity$: Observable<any>;
  entity: any;
  detailForm: FormGroup;

  get showCooperateDiscountControl() {
    return this.detailForm
      .get("customFields")!
      .get("showCooperateDiscount") as FormControl;
  }

  create() {
    this.modalService
      .fromComponent(CorperateDiscountDialogComponent, {
        size: "xl",
        locals: {
          productId: this.entity.id,
        },
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          //   this.revenueScore += result.amount;
          this.refresh();
        }
      });
  }

  update(entity: any) {
    this.modalService
      .fromComponent(CorperateDiscountDialogComponent, {
        size: "xl",
        locals: {
          productId: this.entity.id,
          entity,
        },
      })
      .pipe(take(1))
      .subscribe(result => {
        if (result) {
          //   this.revenueScore += result.amount;
          this.refresh();
        }
      });
  }

  remove(entity: any) {
    this.dataService
      .mutate(DeleteCorporateDiscountDocument, {
        id: entity.id      
    })
      .subscribe(({ deleteCorporateDiscount }) => {
        this.notificationService.success("Deleted.");
        this.refresh();
      });
  }

  ngOnInit() {
    this.detailForm
      .get("customFields")!
      .get("showCooperateDiscount")!
      .valueChanges.subscribe(() => this.detailForm.markAsDirty());
    this.entity$.subscribe((e) => {
      this.entity = e;
      super.configure({
        document: CorporateDiscountsDocument,
        getItems: (result) => {
          return result.corporateDiscounts;
        },
        setVariables: (skip, take) => ({
          options: {
            skip,
            take,
            filter: {
              productId: {
                eq: e.id,
              },
              ...this.filters.createFilterInput(),
            },
            sort: this.sort.createSortInput(),
          },
        }),
        refreshListOnChanges: [
          this.filters.valueChanges,
          this.sort.valueChanges,
        ],
      });
    });

    super.ngOnInit();
  }

  constructor(
    protected dataService: DataService,
    protected modalService: ModalService,
    protected notificationService: NotificationService
  ) {
    super();
    console.log(this.entity$);
  }

  readonly filters = this.createFilterCollection()
    .addIdFilter()
    .addDateFilters()
    .connectToRoute(this.route);

  readonly sort = this.createSortCollection()
    .defaultSort("createdAt", "DESC")
    .addSorts([{ name: "id" }, { name: "updatedAt" }, { name: "createdAt" }]);

  updateUseCooperateDiscount() {
    const enable = this.detailForm
      .get("customFields")
      ?.get("showCooperateDiscount");
    if (enable) {
      enable.setValue(!enable.value);
      enable.markAsDirty();
    }
  }
}
